"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2280],{

/***/ 27347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useDelayedHover; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function useDelayedHover({ open, close, openDelay, closeDelay }) {
  const openTimeout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(-1);
  const closeTimeout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(-1);
  const clearTimeouts = () => {
    window.clearTimeout(openTimeout.current);
    window.clearTimeout(closeTimeout.current);
  };
  const openDropdown = () => {
    clearTimeouts();
    if (openDelay === 0) {
      open();
    } else {
      openTimeout.current = window.setTimeout(open, openDelay);
    }
  };
  const closeDropdown = () => {
    clearTimeouts();
    if (closeDelay === 0) {
      close();
    } else {
      closeTimeout.current = window.setTimeout(close, closeDelay);
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => clearTimeouts, []);
  return { openDropdown, closeDropdown };
}


//# sourceMappingURL=use-delayed-hover.js.map


/***/ }),

/***/ 88002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ Menu; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@mantine/utils/esm/use-hovered/use-hovered.js


function useHovered() {
  const [hovered, setHovered] = (0,react.useState)(-1);
  const resetHovered = () => setHovered(-1);
  return [hovered, { setHovered, resetHovered }];
}


//# sourceMappingURL=use-hovered.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/find-element-ancestor/find-element-ancestor.js
var find_element_ancestor = __webpack_require__(38523);
;// CONCATENATED MODULE: ./node_modules/@mantine/utils/esm/get-context-item-index/get-context-item-index.js


function getContextItemIndex(elementSelector, parentSelector, node) {
  var _a;
  if (!node) {
    return null;
  }
  return Array.from(((_a = (0,find_element_ancestor/* findElementAncestor */.p)(node, parentSelector)) == null ? void 0 : _a.querySelectorAll(elementSelector)) || []).findIndex((element) => element === node);
}


//# sourceMappingURL=get-context-item-index.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-uncontrolled/use-uncontrolled.js
var use_uncontrolled = __webpack_require__(15851);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-did-update/use-did-update.js
var use_did_update = __webpack_require__(37048);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 25 modules
var MantineProvider = __webpack_require__(3241);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-safe-context/create-safe-context.js
var create_safe_context = __webpack_require__(68216);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/Menu.errors.js
const MENU_ERRORS = {
  context: "Menu component was not found in the tree",
  children: "Menu.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
};


//# sourceMappingURL=Menu.errors.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/Menu.context.js



const [MenuContextProvider, useMenuContext] = (0,create_safe_context/* createSafeContext */.R)(MENU_ERRORS.context);


//# sourceMappingURL=Menu.context.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/utils/rem/rem.js
var rem = __webpack_require__(96768);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/MenuDivider/MenuDivider.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((theme) => ({
  divider: {
    marginTop: (0,rem/* rem */.h)(4),
    marginBottom: (0,rem/* rem */.h)(4),
    borderTop: `${(0,rem/* rem */.h)(1)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2]}`
  }
}));

/* harmony default export */ var MenuDivider_styles = (useStyles);
//# sourceMappingURL=MenuDivider.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/MenuDivider/MenuDivider.js






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {};
const MenuDivider = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("MenuDivider", defaultProps, props), { children, className } = _a, others = __objRest(_a, ["children", "className"]);
  const { classNames, styles, unstyled, variant } = useMenuContext();
  const { classes, cx } = MenuDivider_styles(null, { name: "Menu", classNames, styles, unstyled, variant });
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadValues({
    className: cx(classes.divider, className),
    ref
  }, others));
});
MenuDivider.displayName = "@mantine/core/MenuDivider";


//# sourceMappingURL=MenuDivider.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-event-handler/create-event-handler.js
var create_event_handler = __webpack_require__(69328);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Popover/Popover.js + 9 modules
var Popover = __webpack_require__(3317);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/MenuDropdown/MenuDropdown.js






var MenuDropdown_defProp = Object.defineProperty;
var MenuDropdown_getOwnPropSymbols = Object.getOwnPropertySymbols;
var MenuDropdown_hasOwnProp = Object.prototype.hasOwnProperty;
var MenuDropdown_propIsEnum = Object.prototype.propertyIsEnumerable;
var MenuDropdown_defNormalProp = (obj, key, value) => key in obj ? MenuDropdown_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var MenuDropdown_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (MenuDropdown_hasOwnProp.call(b, prop))
      MenuDropdown_defNormalProp(a, prop, b[prop]);
  if (MenuDropdown_getOwnPropSymbols)
    for (var prop of MenuDropdown_getOwnPropSymbols(b)) {
      if (MenuDropdown_propIsEnum.call(b, prop))
        MenuDropdown_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var MenuDropdown_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (MenuDropdown_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && MenuDropdown_getOwnPropSymbols)
    for (var prop of MenuDropdown_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && MenuDropdown_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MenuDropdown_defaultProps = {};
function MenuDropdown(props) {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("MenuDropdown", MenuDropdown_defaultProps, props), { children, onMouseEnter, onMouseLeave } = _a, others = MenuDropdown_objRest(_a, ["children", "onMouseEnter", "onMouseLeave"]);
  const wrapperRef = (0,react.useRef)();
  const ctx = useMenuContext();
  const handleKeyDown = (event) => {
    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      event.preventDefault();
      wrapperRef.current.querySelectorAll("[data-menu-item]")[0].focus();
    }
  };
  const handleMouseEnter = (0,create_event_handler/* createEventHandler */.x)(onMouseEnter, () => ctx.trigger === "hover" && ctx.openDropdown());
  const handleMouseLeave = (0,create_event_handler/* createEventHandler */.x)(onMouseLeave, () => ctx.trigger === "hover" && ctx.closeDropdown());
  return /* @__PURE__ */ react.createElement(Popover/* Popover.Dropdown */.J.Dropdown, MenuDropdown_spreadValues({
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    role: "menu",
    "aria-orientation": "vertical"
  }, others), /* @__PURE__ */ react.createElement("div", {
    tabIndex: -1,
    "data-menu-dropdown": true,
    "data-autofocus": true,
    onKeyDown: handleKeyDown,
    ref: wrapperRef,
    style: { outline: 0 }
  }, children));
}
MenuDropdown.displayName = "@mantine/core/MenuDropdown";


//# sourceMappingURL=MenuDropdown.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-scoped-keydown-handler/create-scoped-keydown-handler.js
var create_scoped_keydown_handler = __webpack_require__(16650);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-polymorphic-component/create-polymorphic-component.js
var create_polymorphic_component = __webpack_require__(48427);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-merged-ref/use-merged-ref.js
var use_merged_ref = __webpack_require__(80665);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/MenuItem/MenuItem.styles.js


var MenuItem_styles_defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var MenuItem_styles_getOwnPropSymbols = Object.getOwnPropertySymbols;
var MenuItem_styles_hasOwnProp = Object.prototype.hasOwnProperty;
var MenuItem_styles_propIsEnum = Object.prototype.propertyIsEnumerable;
var MenuItem_styles_defNormalProp = (obj, key, value) => key in obj ? MenuItem_styles_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var MenuItem_styles_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (MenuItem_styles_hasOwnProp.call(b, prop))
      MenuItem_styles_defNormalProp(a, prop, b[prop]);
  if (MenuItem_styles_getOwnPropSymbols)
    for (var prop of MenuItem_styles_getOwnPropSymbols(b)) {
      if (MenuItem_styles_propIsEnum.call(b, prop))
        MenuItem_styles_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var MenuItem_styles_useStyles = (0,create_styles/* createStyles */.k)((theme, { color, radius }) => ({
  item: __spreadProps(MenuItem_styles_spreadValues({}, theme.fn.fontStyles()), {
    WebkitTapHighlightColor: "transparent",
    fontSize: theme.fontSizes.sm,
    border: 0,
    backgroundColor: "transparent",
    outline: 0,
    width: "100%",
    textAlign: "left",
    textDecoration: "none",
    boxSizing: "border-box",
    padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
    cursor: "pointer",
    borderRadius: theme.fn.radius(radius),
    color: color ? theme.fn.variant({ variant: "filled", primaryFallback: false, color }).background : theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
    display: "flex",
    alignItems: "center",
    "&:disabled": {
      color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5],
      pointerEvents: "none",
      userSelect: "none"
    },
    "&[data-hovered]": {
      backgroundColor: color ? theme.fn.variant({ variant: "light", color }).background : theme.colorScheme === "dark" ? theme.fn.rgba(theme.colors.dark[3], 0.35) : theme.colors.gray[1]
    }
  }),
  itemLabel: {
    flex: 1
  },
  itemIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: theme.spacing.xs
  },
  itemRightSection: {}
}));

/* harmony default export */ var MenuItem_styles = (MenuItem_styles_useStyles);
//# sourceMappingURL=MenuItem.styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/MenuItem/MenuItem.js








var MenuItem_defProp = Object.defineProperty;
var MenuItem_defProps = Object.defineProperties;
var MenuItem_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var MenuItem_getOwnPropSymbols = Object.getOwnPropertySymbols;
var MenuItem_hasOwnProp = Object.prototype.hasOwnProperty;
var MenuItem_propIsEnum = Object.prototype.propertyIsEnumerable;
var MenuItem_defNormalProp = (obj, key, value) => key in obj ? MenuItem_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var MenuItem_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (MenuItem_hasOwnProp.call(b, prop))
      MenuItem_defNormalProp(a, prop, b[prop]);
  if (MenuItem_getOwnPropSymbols)
    for (var prop of MenuItem_getOwnPropSymbols(b)) {
      if (MenuItem_propIsEnum.call(b, prop))
        MenuItem_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var MenuItem_spreadProps = (a, b) => MenuItem_defProps(a, MenuItem_getOwnPropDescs(b));
var MenuItem_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (MenuItem_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && MenuItem_getOwnPropSymbols)
    for (var prop of MenuItem_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && MenuItem_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MenuItem_defaultProps = {};
const _MenuItem = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("MenuItem", MenuItem_defaultProps, props), { children, className, color, closeMenuOnClick, icon, rightSection } = _a, others = MenuItem_objRest(_a, ["children", "className", "color", "closeMenuOnClick", "icon", "rightSection"]);
  const ctx = useMenuContext();
  const { classes, cx, theme } = MenuItem_styles({ radius: ctx.radius, color }, {
    name: "Menu",
    classNames: ctx.classNames,
    styles: ctx.styles,
    unstyled: ctx.unstyled,
    variant: ctx.variant
  });
  const itemRef = (0,react.useRef)();
  const itemIndex = ctx.getItemIndex(itemRef.current);
  const _others = others;
  const handleMouseLeave = (0,create_event_handler/* createEventHandler */.x)(_others.onMouseLeave, () => ctx.setHovered(-1));
  const handleMouseEnter = (0,create_event_handler/* createEventHandler */.x)(_others.onMouseEnter, () => ctx.setHovered(ctx.getItemIndex(itemRef.current)));
  const handleClick = (0,create_event_handler/* createEventHandler */.x)(_others.onClick, () => {
    if (typeof closeMenuOnClick === "boolean") {
      closeMenuOnClick && ctx.closeDropdownImmediately();
    } else {
      ctx.closeOnItemClick && ctx.closeDropdownImmediately();
    }
  });
  const handleFocus = (0,create_event_handler/* createEventHandler */.x)(_others.onFocus, () => ctx.setHovered(ctx.getItemIndex(itemRef.current)));
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, MenuItem_spreadProps(MenuItem_spreadValues({
    component: "button",
    type: "button"
  }, others), {
    tabIndex: -1,
    onFocus: handleFocus,
    className: cx(classes.item, className),
    ref: (0,use_merged_ref/* useMergedRef */.Y)(itemRef, ref),
    role: "menuitem",
    "data-menu-item": true,
    "data-hovered": ctx.hovered === itemIndex ? true : void 0,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClick: handleClick,
    onKeyDown: (0,create_scoped_keydown_handler/* createScopedKeydownHandler */.R)({
      siblingSelector: "[data-menu-item]",
      parentSelector: "[data-menu-dropdown]",
      activateOnFocus: false,
      loop: ctx.loop,
      dir: theme.dir,
      orientation: "vertical",
      onKeyDown: _others.onKeydown
    })
  }), icon && /* @__PURE__ */ react.createElement("div", {
    className: classes.itemIcon
  }, icon), children && /* @__PURE__ */ react.createElement("div", {
    className: classes.itemLabel
  }, children), rightSection && /* @__PURE__ */ react.createElement("div", {
    className: classes.itemRightSection
  }, rightSection));
});
_MenuItem.displayName = "@mantine/core/MenuItem";
const MenuItem = (0,create_polymorphic_component/* createPolymorphicComponent */.F)(_MenuItem);


//# sourceMappingURL=MenuItem.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/MenuLabel/MenuLabel.styles.js


var MenuLabel_styles_useStyles = (0,create_styles/* createStyles */.k)((theme) => ({
  label: {
    color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6],
    fontWeight: 500,
    fontSize: theme.fontSizes.xs,
    padding: `calc(${theme.spacing.xs} / 2) ${theme.spacing.sm}`,
    cursor: "default"
  }
}));

/* harmony default export */ var MenuLabel_styles = (MenuLabel_styles_useStyles);
//# sourceMappingURL=MenuLabel.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/MenuLabel/MenuLabel.js






var MenuLabel_defProp = Object.defineProperty;
var MenuLabel_getOwnPropSymbols = Object.getOwnPropertySymbols;
var MenuLabel_hasOwnProp = Object.prototype.hasOwnProperty;
var MenuLabel_propIsEnum = Object.prototype.propertyIsEnumerable;
var MenuLabel_defNormalProp = (obj, key, value) => key in obj ? MenuLabel_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var MenuLabel_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (MenuLabel_hasOwnProp.call(b, prop))
      MenuLabel_defNormalProp(a, prop, b[prop]);
  if (MenuLabel_getOwnPropSymbols)
    for (var prop of MenuLabel_getOwnPropSymbols(b)) {
      if (MenuLabel_propIsEnum.call(b, prop))
        MenuLabel_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var MenuLabel_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (MenuLabel_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && MenuLabel_getOwnPropSymbols)
    for (var prop of MenuLabel_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && MenuLabel_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MenuLabel_defaultProps = {};
const MenuLabel = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("MenuLabel", MenuLabel_defaultProps, props), { children, className } = _a, others = MenuLabel_objRest(_a, ["children", "className"]);
  const { classNames, styles, unstyled, variant } = useMenuContext();
  const { classes, cx } = MenuLabel_styles(null, { name: "Menu", classNames, styles, unstyled, variant });
  return /* @__PURE__ */ react.createElement(Text/* Text */.x, MenuLabel_spreadValues({
    className: cx(classes.label, className),
    ref
  }, others), children);
});
MenuLabel.displayName = "@mantine/core/MenuLabel";


//# sourceMappingURL=MenuLabel.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/is-element/is-element.js
var is_element = __webpack_require__(24241);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/MenuTarget/MenuTarget.js







var MenuTarget_defProp = Object.defineProperty;
var MenuTarget_getOwnPropSymbols = Object.getOwnPropertySymbols;
var MenuTarget_hasOwnProp = Object.prototype.hasOwnProperty;
var MenuTarget_propIsEnum = Object.prototype.propertyIsEnumerable;
var MenuTarget_defNormalProp = (obj, key, value) => key in obj ? MenuTarget_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var MenuTarget_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (MenuTarget_hasOwnProp.call(b, prop))
      MenuTarget_defNormalProp(a, prop, b[prop]);
  if (MenuTarget_getOwnPropSymbols)
    for (var prop of MenuTarget_getOwnPropSymbols(b)) {
      if (MenuTarget_propIsEnum.call(b, prop))
        MenuTarget_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var MenuTarget_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (MenuTarget_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && MenuTarget_getOwnPropSymbols)
    for (var prop of MenuTarget_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && MenuTarget_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MenuTarget_defaultProps = {
  refProp: "ref"
};
const MenuTarget = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("MenuTarget", MenuTarget_defaultProps, props), { children, refProp } = _a, others = MenuTarget_objRest(_a, ["children", "refProp"]);
  if (!(0,is_element/* isElement */.k)(children)) {
    throw new Error(MENU_ERRORS.children);
  }
  const ctx = useMenuContext();
  const onClick = (0,create_event_handler/* createEventHandler */.x)(children.props.onClick, () => ctx.trigger === "click" && ctx.toggleDropdown());
  const onMouseEnter = (0,create_event_handler/* createEventHandler */.x)(children.props.onMouseEnter, () => ctx.trigger === "hover" && ctx.openDropdown());
  const onMouseLeave = (0,create_event_handler/* createEventHandler */.x)(children.props.onMouseLeave, () => ctx.trigger === "hover" && ctx.closeDropdown());
  return /* @__PURE__ */ react.createElement(Popover/* Popover.Target */.J.Target, MenuTarget_spreadValues({
    refProp,
    popupType: "menu",
    ref
  }, others), (0,react.cloneElement)(children, {
    onClick,
    onMouseEnter,
    onMouseLeave,
    "data-expanded": ctx.opened ? true : void 0
  }));
});
MenuTarget.displayName = "@mantine/core/MenuTarget";


//# sourceMappingURL=MenuTarget.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/Menu.styles.js


var Menu_styles_useStyles = (0,create_styles/* createStyles */.k)({
  dropdown: { padding: (0,rem/* rem */.h)(4) }
});

/* harmony default export */ var Menu_styles = (Menu_styles_useStyles);
//# sourceMappingURL=Menu.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Floating/use-delayed-hover.js
var use_delayed_hover = __webpack_require__(27347);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Menu/Menu.js














var Menu_defProp = Object.defineProperty;
var Menu_defProps = Object.defineProperties;
var Menu_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Menu_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Menu_hasOwnProp = Object.prototype.hasOwnProperty;
var Menu_propIsEnum = Object.prototype.propertyIsEnumerable;
var Menu_defNormalProp = (obj, key, value) => key in obj ? Menu_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Menu_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Menu_hasOwnProp.call(b, prop))
      Menu_defNormalProp(a, prop, b[prop]);
  if (Menu_getOwnPropSymbols)
    for (var prop of Menu_getOwnPropSymbols(b)) {
      if (Menu_propIsEnum.call(b, prop))
        Menu_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Menu_spreadProps = (a, b) => Menu_defProps(a, Menu_getOwnPropDescs(b));
var Menu_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Menu_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Menu_getOwnPropSymbols)
    for (var prop of Menu_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Menu_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Menu_defaultProps = {
  closeOnItemClick: true,
  loop: true,
  trigger: "click",
  openDelay: 0,
  closeDelay: 100
};
function Menu(props) {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Menu", Menu_defaultProps, props), {
    children,
    onOpen,
    onClose,
    opened,
    defaultOpened,
    onChange,
    closeOnItemClick,
    loop,
    closeOnEscape,
    trigger,
    openDelay,
    closeDelay,
    classNames,
    styles,
    unstyled,
    radius,
    variant
  } = _a, others = Menu_objRest(_a, [
    "children",
    "onOpen",
    "onClose",
    "opened",
    "defaultOpened",
    "onChange",
    "closeOnItemClick",
    "loop",
    "closeOnEscape",
    "trigger",
    "openDelay",
    "closeDelay",
    "classNames",
    "styles",
    "unstyled",
    "radius",
    "variant"
  ]);
  const { classes, cx } = Menu_styles();
  const [hovered, { setHovered, resetHovered }] = useHovered();
  const [_opened, setOpened] = (0,use_uncontrolled/* useUncontrolled */.C)({
    value: opened,
    defaultValue: defaultOpened,
    finalValue: false,
    onChange
  });
  const close = () => {
    setOpened(false);
    _opened && (onClose == null ? void 0 : onClose());
  };
  const open = () => {
    setOpened(true);
    !_opened && (onOpen == null ? void 0 : onOpen());
  };
  const toggleDropdown = () => _opened ? close() : open();
  const { openDropdown, closeDropdown } = (0,use_delayed_hover/* useDelayedHover */.U)({ open, close, closeDelay, openDelay });
  const getItemIndex = (node) => getContextItemIndex("[data-menu-item]", "[data-menu-dropdown]", node);
  (0,use_did_update/* useDidUpdate */.l)(() => {
    resetHovered();
  }, [_opened]);
  return /* @__PURE__ */ react.createElement(MenuContextProvider, {
    value: {
      opened: _opened,
      toggleDropdown,
      getItemIndex,
      hovered,
      setHovered,
      closeOnItemClick,
      closeDropdown: trigger === "click" ? close : closeDropdown,
      openDropdown: trigger === "click" ? open : openDropdown,
      closeDropdownImmediately: close,
      loop,
      trigger,
      radius,
      classNames,
      styles,
      unstyled,
      variant
    }
  }, /* @__PURE__ */ react.createElement(Popover/* Popover */.J, Menu_spreadProps(Menu_spreadValues({}, others), {
    radius,
    opened: _opened,
    onChange: toggleDropdown,
    defaultOpened,
    trapFocus: trigger === "click",
    closeOnEscape: closeOnEscape && trigger === "click",
    __staticSelector: "Menu",
    classNames: Menu_spreadProps(Menu_spreadValues({}, classNames), { dropdown: cx(classes.dropdown, classNames == null ? void 0 : classNames.dropdown) }),
    styles,
    unstyled,
    variant
  }), children));
}
Menu.displayName = "@mantine/core/Menu";
Menu.Item = MenuItem;
Menu.Label = MenuLabel;
Menu.Dropdown = MenuDropdown;
Menu.Target = MenuTarget;
Menu.Divider = MenuDivider;


//# sourceMappingURL=Menu.js.map


/***/ }),

/***/ 69328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ createEventHandler; }
/* harmony export */ });
function createEventHandler(parentEventHandler, eventHandler) {
  return (event) => {
    parentEventHandler == null ? void 0 : parentEventHandler(event);
    eventHandler == null ? void 0 : eventHandler(event);
  };
}


//# sourceMappingURL=create-event-handler.js.map


/***/ }),

/***/ 16650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ createScopedKeydownHandler; }
/* harmony export */ });
/* harmony import */ var _find_element_ancestor_find_element_ancestor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38523);


function getPreviousIndex(current, elements, loop) {
  for (let i = current - 1; i >= 0; i -= 1) {
    if (!elements[i].disabled) {
      return i;
    }
  }
  if (loop) {
    for (let i = elements.length - 1; i > -1; i -= 1) {
      if (!elements[i].disabled) {
        return i;
      }
    }
  }
  return current;
}
function getNextIndex(current, elements, loop) {
  for (let i = current + 1; i < elements.length; i += 1) {
    if (!elements[i].disabled) {
      return i;
    }
  }
  if (loop) {
    for (let i = 0; i < elements.length; i += 1) {
      if (!elements[i].disabled) {
        return i;
      }
    }
  }
  return current;
}
function onSameLevel(target, sibling, parentSelector) {
  return (0,_find_element_ancestor_find_element_ancestor_js__WEBPACK_IMPORTED_MODULE_0__/* .findElementAncestor */ .p)(target, parentSelector) === (0,_find_element_ancestor_find_element_ancestor_js__WEBPACK_IMPORTED_MODULE_0__/* .findElementAncestor */ .p)(sibling, parentSelector);
}
function createScopedKeydownHandler({
  parentSelector,
  siblingSelector,
  onKeyDown,
  loop = true,
  activateOnFocus = false,
  dir = "rtl",
  orientation
}) {
  return (event) => {
    var _a;
    onKeyDown == null ? void 0 : onKeyDown(event);
    const elements = Array.from(((_a = (0,_find_element_ancestor_find_element_ancestor_js__WEBPACK_IMPORTED_MODULE_0__/* .findElementAncestor */ .p)(event.currentTarget, parentSelector)) == null ? void 0 : _a.querySelectorAll(siblingSelector)) || []).filter((node) => onSameLevel(event.currentTarget, node, parentSelector));
    const current = elements.findIndex((el) => event.currentTarget === el);
    const _nextIndex = getNextIndex(current, elements, loop);
    const _previousIndex = getPreviousIndex(current, elements, loop);
    const nextIndex = dir === "rtl" ? _previousIndex : _nextIndex;
    const previousIndex = dir === "rtl" ? _nextIndex : _previousIndex;
    switch (event.key) {
      case "ArrowRight": {
        if (orientation === "horizontal") {
          event.stopPropagation();
          event.preventDefault();
          elements[nextIndex].focus();
          activateOnFocus && elements[nextIndex].click();
        }
        break;
      }
      case "ArrowLeft": {
        if (orientation === "horizontal") {
          event.stopPropagation();
          event.preventDefault();
          elements[previousIndex].focus();
          activateOnFocus && elements[previousIndex].click();
        }
        break;
      }
      case "ArrowUp": {
        if (orientation === "vertical") {
          event.stopPropagation();
          event.preventDefault();
          elements[_previousIndex].focus();
          activateOnFocus && elements[_previousIndex].click();
        }
        break;
      }
      case "ArrowDown": {
        if (orientation === "vertical") {
          event.stopPropagation();
          event.preventDefault();
          elements[_nextIndex].focus();
          activateOnFocus && elements[_nextIndex].click();
        }
        break;
      }
      case "Home": {
        event.stopPropagation();
        event.preventDefault();
        !elements[0].disabled && elements[0].focus();
        break;
      }
      case "End": {
        event.stopPropagation();
        event.preventDefault();
        const last = elements.length - 1;
        !elements[last].disabled && elements[last].focus();
        break;
      }
    }
  };
}


//# sourceMappingURL=create-scoped-keydown-handler.js.map


/***/ }),

/***/ 38523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ findElementAncestor; }
/* harmony export */ });
function findElementAncestor(element, selector) {
  let _element = element;
  while ((_element = _element.parentElement) && !_element.matches(selector))
    ;
  return _element;
}


//# sourceMappingURL=find-element-ancestor.js.map


/***/ }),

/***/ 66409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ use100vh; }
/* harmony export */ });
/* unused harmony export measureHeight */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

var warned = false;
var Div100vh = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_a, ref) {
    var style = _a.style, other = __rest(_a, ["style"]);
    var height = use100vh();
    // TODO: warn only in development
    if (!warned && (style === null || style === void 0 ? void 0 : style.height)) {
        warned = true;
        console.warn('<Div100vh /> overrides the height property of the style prop');
    }
    var styleWithRealHeight = __assign(__assign({}, style), { height: height ? height + "px" : '100vh' });
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", __assign({ ref: ref, style: styleWithRealHeight }, other));
});
Div100vh.displayName = 'Div100vh';
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Div100vh)));
function use100vh() {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(measureHeight), height = _a[0], setHeight = _a[1];
    var wasRenderedOnClientAtLeastOnce = useWasRenderedOnClientAtLeastOnce();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (!wasRenderedOnClientAtLeastOnce)
            return;
        function setMeasuredHeight() {
            var measuredHeight = measureHeight();
            setHeight(measuredHeight);
        }
        window.addEventListener('resize', setMeasuredHeight);
        return function () { return window.removeEventListener('resize', setMeasuredHeight); };
    }, [wasRenderedOnClientAtLeastOnce]);
    return wasRenderedOnClientAtLeastOnce ? height : null;
}
function measureHeight() {
    if (!isClient())
        return null;
    return window.innerHeight;
}
// Once we ended up on the client, the first render must look the same as on
// the server so hydration happens without problems. _Then_ we immediately
// schedule a subsequent update and return the height measured on the client.
// It's not needed for CSR-only apps, but is critical for SSR.
function useWasRenderedOnClientAtLeastOnce() {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), wasRenderedOnClientAtLeastOnce = _a[0], setWasRenderedOnClientAtLeastOnce = _a[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (isClient()) {
            setWasRenderedOnClientAtLeastOnce(true);
        }
    }, []);
    return wasRenderedOnClientAtLeastOnce;
}
function isClient() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}


/***/ })

}]);